module.exports = __webpack_public_path__ + "img/ic_prev_desktop.f590ed70.svg";